




























import BaseFormEdit from "../../models/base.form.edit";
import { Component, Watch } from "vue-property-decorator";

@Component({})
export default class Edit extends BaseFormEdit {
  form = {
    days: null,
    type: null,
    status: null,

    types: [],
    patientStatuses: [],
    donorStatuses: [],
    typesLocalized: [],
    patientStatusesLocalized: [],
    donorStatuseLocalizeds: []
  } as any;

  statuses:any = [];

  @Watch("form.type")
  onTypeChanged(val: string, oldVal: string) {
    const type = this.form.types.find((x: any) => x.key == val);
    if (type && type.value === 'Пациент') {
      this.statuses = this.form.patientStatusesLocalized;
    } else if (type && type.value === 'Донор в работе') {
      this.statuses = this.form.donorStatusesLocalized;
    } else if (type && type.value === 'Родственный донор') {
      this.statuses = this.form.donorRelativeStatusesLocalized;
    } else if (type && type.value === 'Анкета донора') {
      this.statuses = this.form.donorFormStatusesLocalized;
    } else {
      this.statuses = [];
    }
  }
}
